import React from 'react'
import styles from '../Messages.module.css'

const GameStatus = props => {
  let statusMessage = props.statusMessage
  if (props.show) {
    statusMessage = `The game is finished.  You ${props.gameStatus === 'finished' ? 'Won!!!' : 'Lost...'}`
  }
  
  return (
    <div className={styles.GameStatus}>
      {statusMessage}
    </div>
  )
}

export default GameStatus
